<div class="modal-shell-container {{ size }}">
  <div class="modal-title">{{ titleKey | translate : titleParam }}</div>
  <div class="close-icon" (click)="closeDialog('close')" *ngIf="showIconClose">
    <img src="assets/icons/Close.svg" alt="close_icon" />
  </div>
  <ng-container #dialogContainer></ng-container>
  <div class="px-2 py-5" *ngIf="!!confirmMessage">
    {{ confirmMessage | translate }}
  </div>
</div>
